import React, { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";

export default function ApprovedReviews() {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    const load = async () => {
      const { data, error } = await supabase
        .from("reviews")
        .select("*")
        .eq("aprobada", true)           // 👈 Campo CORRECTO
        .order("created_at", { ascending: false });

      console.log("🟢 Reseñas aprobadas cargadas:", data);
      console.log("⚠️ Error:", error);

      if (!error) setReviews(data);
    };

    load();
  }, []);

  return (
    <div style={{ padding: "40px", textAlign: "center" }}>
      <h2>Opiniones de clientes (Aprobadas)</h2>

      {reviews.length === 0 && (
        <p>Todavía no hay reseñas aprobadas.</p>
      )}

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: "30px",
        }}
      >
        {reviews.map((r) => (
          <div
            key={r.id}
            style={{
              background: "white",
              padding: "20px",
              borderRadius: "10px",
              boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
              width: "250px",
              textAlign: "left",
            }}
          >
            <h4 style={{ color: "#4B6CB7" }}>{r.nombre}</h4>
            <p>{r.comentario}</p>
            <p>⭐ {r.rating}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
